<main class="content-container">
  <div class="container" [class.welcome]="isWelcome">
    <app-on-boarding-welcome
      (beginClicked)="onBeginClicked()"
      *ngIf="isWelcome; else stepper"></app-on-boarding-welcome>
    <ng-template #stepper>
      <app-stepper
        [title]="stepperTitle | translate"
        [currentStep]="currentStep"
        [totalSteps]="3"
        [showStepper]="currentStep !== 4"
        [showButtons]="true"
        [showLogo]="true"
        [backDisabled]="backDisabled"
        [nextDisabled]="nextDisabled"
        [backButtonText]="backButtonText"
        [nextButtonText]="nextButtonText"
        [nextHidden]="userIsNewWorker && currentStep === 4"
        (navButtonClicked)="updateStep($event)">
        <div [ngSwitch]="currentStep">
          <app-sign-document
            [document]="document"
            (signedContract)="onSignedContract()"
            *ngSwitchCase="1"></app-sign-document>
          <app-on-boarding-second-step [boarding]="boardingData" *ngSwitchCase="2"></app-on-boarding-second-step>
          <app-on-boarding-third-step [boarding]="boardingData" *ngSwitchCase="3"></app-on-boarding-third-step>
          <app-on-boarding-completed *ngSwitchCase="4"></app-on-boarding-completed>
        </div>
      </app-stepper>
    </ng-template>
    <div class="logout-container">
      <i class="app-icon-logout icon" (click)="logout()"></i>
    </div>
  </div>
</main>
